<template>
    <div class="recru">
    <div class="banner">
      <el-image :src="require('../../assets/home/recruit.png')" class="banner-img"></el-image>
    </div>
    <div class="tag">
        <div class="title">
            <div class="slogan">招贤纳士</div>
            <div class="sloganen">TALENT RECRUITMENT</div>
        </div>
    </div>

      <div id="about-meau">
          <el-tabs v-model="activeName" @tab-click="planMenuSelect">
          <el-tab-pane v-for="item in menus" :key="item.id" :name="item.type" :label=" item.name">
            {{ item.name }}
            </el-tab-pane>
          </el-tabs>
      </div>
        <div class="new-list" >
        <el-row v-for ="(recruit, index) in recruitList" :key="index" class="xuxian" >
          <el-col :span="1"><div class="recruit-icon"></div></el-col>
          <el-col :span="10" :offset="1">
            <div class="recruit"  >{{recruit.title}}</div>
            <div class="recruit-summary"  >{{recruit.summary}}</div>
          
            </el-col>
          <el-col :span="5" :offset="3">
             <div class="recruit"></div>
            <div class="recruit-summary" >
              <i class="el-icon-location"></i>
              {{recruit.img}}</div>
            </el-col>
           <el-col :span="2" :offset="2">
             <div class="recruit"></div>
             
             <div class="recruit-time" >
               <i class=" el-icon-caret-bottom" v-show="tag!=recruit.id" @click="openRecruit(recruit.id)"></i>
               <i class=" el-icon-caret-top" v-show="tag==recruit.id" @click="closeRecruit(recruit.id)"></i>
               </div>
             </el-col>
                <el-row  v-show="tag==recruit.id" class="xuxian-top">
                <el-col :span="24">
                <p class="ql-editor" v-html='recruit.content'></p>
                </el-col>
                </el-row>
        </el-row>

        </div>
    </div>

</template>
<script>
import { getRequest } from "../../util/api";
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
export default {
  data() {
    return {
      menus: [],
      recruitList:[],
       activeName: 'zxns',
        tag:0,
    };
  },
  mounted() {
    this.getMenuChildren();
    // this.activeName=this.$route.query.id;
    this.getList(5)
  },
  methods: {
    planMenuSelect(tab, event) {
      let that = this;
       that.tag=1;
       that.getList(5); 
    },
    getMenuChildren() {
      let that = this;
      let params = {
        pid: 6
      };
      getRequest("/menus/type", params).then(function(res) {
        if (res.data.meta.code == 1) {
          console.log("进来了hah");
          that.menus = res.data.data;
        }
      });
    },
            getList(key) {
     let origin = document.location.origin
      let that = this
      that.imageUrl='http://www.lensyn.com:8088/';
      let params = {
        type: key,
        keyWords: that.keyWords,
        pageStart: 0,
        pageSize: 1000
      }
      getRequest('/news/list', params).then(function(res) {
        if (res.data.meta.code === 1) {
          that.recruitList = res.data.data
        }
      })
    },
     openRecruit(id){
      let that = this
     
       
      let params = {
        id: id
      }
       getRequest('/news/content', params).then(function(res) {
           that.tag=res.data.data.id
        
       })
    },
    closeRecruit(id){
      this.tag=0
    }
  }
};
</script>
<style>
.recruit-icon{
   width: 50px;
    height: 50px;
    background:  #3199E9;
    background-image: url('../../assets/recruit.png');
    background-repeat: no-repeat;
    background-position: center;
   position: relative;
}
.recruit-time{
  text-align: right;
  color: #3199E9;
    font-size: 24px;
    cursor: pointer;
}
.recruit-summary{
  color: #0E2336;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}
.recruit {
  min-height: 30px;
  color: #0E2336;
  font-size: 20px;
  line-height: 30px;
  font-weight: 500;
}
.recru{
  width: 99%;
}

/* .xuxian-top img{
  width: 100%;
  height: 100%;
} */
</style>
<style src="../../css/banner.css"></style>


// WEBPACK FOOTER //
// src/components/content/Recruit.vue